import { c as _c } from "react/compiler-runtime";
import type { VaultKind } from '@onefootprint/request-types';
import type { EntityOrgStatus } from '@onefootprint/request-types/dashboard';
import { Button, Tabs } from '@onefootprint/ui';
import Head from 'next/head';
import { parseAsStringLiteral, useQueryState } from 'nuqs';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorComponent } from '@/components';
import PermissionGate from '@/components/permission-gate';
import SectionHeader from '@/components/section-header';
import usePermissions from '@/hooks/use-permissions';
import CustomStatusAddDialog from './components/custom-status-add-dialog';
import CustomStatusCard from './components/custom-status-card';
import CustomStatusLoadingShimmer from './components/custom-status-loading-shimmer';
import useCustomStatuses from './use-custom-statuses';
const tabValues = ['person', 'business'] as const;
type StatusTab = (typeof tabValues)[number];
const Statuses = () => {
  const $ = _c(85);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "pages.statuses"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("settings", t0);
  const {
    hasPermission
  } = usePermissions();
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = parseAsStringLiteral(tabValues).withDefault("person");
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [tab, setTab] = useQueryState("tab", t1);
  const [isAddDialogOpen, setIsAddDialogOpen] = useState(false);
  const {
    data,
    errorMessage,
    isLoading
  } = useCustomStatuses();
  let t2;
  if ($[2] !== hasPermission) {
    t2 = hasPermission("org_settings");
    $[2] = hasPermission;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const canEdit = t2;
  let t10;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[4] !== canEdit || $[5] !== data || $[6] !== errorMessage || $[7] !== isLoading || $[8] !== setTab || $[9] !== t || $[10] !== tab) {
    const statuses = data?.filter(status => status.entityType === tab) ?? [];
    let t11;
    if ($[19] !== t) {
      t11 = t(_temp);
      $[19] = t;
      $[20] = t11;
    } else {
      t11 = $[20];
    }
    let t12;
    if ($[21] !== t11) {
      t12 = {
        label: t11,
        value: "person"
      };
      $[21] = t11;
      $[22] = t12;
    } else {
      t12 = $[22];
    }
    let t13;
    if ($[23] !== t) {
      t13 = t(_temp2);
      $[23] = t;
      $[24] = t13;
    } else {
      t13 = $[24];
    }
    let t14;
    if ($[25] !== t13) {
      t14 = {
        label: t13,
        value: "business"
      };
      $[25] = t13;
      $[26] = t14;
    } else {
      t14 = $[26];
    }
    let t15;
    if ($[27] !== t12 || $[28] !== t14) {
      t15 = [t12, t14];
      $[27] = t12;
      $[28] = t14;
      $[29] = t15;
    } else {
      t15 = $[29];
    }
    const tabs = t15;
    let t16;
    if ($[30] !== t || $[31] !== tab) {
      t16 = tab === "person" ? t(_temp3) : t(_temp4);
      $[30] = t;
      $[31] = tab;
      $[32] = t16;
    } else {
      t16 = $[32];
    }
    const emptyText = t16;
    let t17;
    if ($[33] !== t) {
      t17 = t(_temp5);
      $[33] = t;
      $[34] = t17;
    } else {
      t17 = $[34];
    }
    if ($[35] !== t17) {
      t10 = <Head><title>{t17}</title></Head>;
      $[35] = t17;
      $[36] = t10;
    } else {
      t10 = $[36];
    }
    let t18;
    if ($[37] !== t) {
      t18 = t(_temp6);
      $[37] = t;
      $[38] = t18;
    } else {
      t18 = $[38];
    }
    if ($[39] !== t18) {
      t7 = <header className="hidden md:flex items-center justify-between mb-6"><h2 className="text-heading-2">{t18}</h2></header>;
      $[39] = t18;
      $[40] = t7;
    } else {
      t7 = $[40];
    }
    let t19;
    if ($[41] !== t) {
      t19 = t(_temp7);
      $[41] = t;
      $[42] = t19;
    } else {
      t19 = $[42];
    }
    let t20;
    if ($[43] !== t) {
      t20 = t(_temp8);
      $[43] = t;
      $[44] = t20;
    } else {
      t20 = $[44];
    }
    let t21;
    if ($[45] !== t) {
      t21 = t(_temp9);
      $[45] = t;
      $[46] = t21;
    } else {
      t21 = $[46];
    }
    let t22;
    if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
      t22 = () => setIsAddDialogOpen(true);
      $[47] = t22;
    } else {
      t22 = $[47];
    }
    let t23;
    if ($[48] !== t) {
      t23 = t(_temp10);
      $[48] = t;
      $[49] = t23;
    } else {
      t23 = $[49];
    }
    let t24;
    if ($[50] !== t23) {
      t24 = <Button onClick={t22}>{t23}</Button>;
      $[50] = t23;
      $[51] = t24;
    } else {
      t24 = $[51];
    }
    let t25;
    if ($[52] !== t21 || $[53] !== t24) {
      t25 = <PermissionGate scopeKind="org_settings" fallbackText={t21}>{t24}</PermissionGate>;
      $[52] = t21;
      $[53] = t24;
      $[54] = t25;
    } else {
      t25 = $[54];
    }
    if ($[55] !== t19 || $[56] !== t20 || $[57] !== t25) {
      t8 = <SectionHeader title={t19} subtitle={t20}>{t25}</SectionHeader>;
      $[55] = t19;
      $[56] = t20;
      $[57] = t25;
      $[58] = t8;
    } else {
      t8 = $[58];
    }
    if ($[59] !== setTab || $[60] !== tab || $[61] !== tabs) {
      t9 = <Tabs options={tabs} onChange={setTab} value={tab} />;
      $[59] = setTab;
      $[60] = tab;
      $[61] = tabs;
      $[62] = t9;
    } else {
      t9 = $[62];
    }
    t3 = "mt-4 flex flex-col gap-4";
    if ($[63] !== errorMessage) {
      t4 = errorMessage && <ErrorComponent error={errorMessage} />;
      $[63] = errorMessage;
      $[64] = t4;
    } else {
      t4 = $[64];
    }
    if ($[65] !== isLoading) {
      t5 = isLoading && <CustomStatusLoadingShimmer />;
      $[65] = isLoading;
      $[66] = t5;
    } else {
      t5 = $[66];
    }
    t6 = data && <><OnboardingOutcomeCard entityType={tab} />{statuses.map(status_0 => <CustomStatusCard key={status_0.id} customStatus={status_0} canEdit={canEdit} shouldShowSlug={true} />)}{statuses.length === 0 && <p className="text-body-2 text-tertiary">{emptyText}</p>}</>;
    $[4] = canEdit;
    $[5] = data;
    $[6] = errorMessage;
    $[7] = isLoading;
    $[8] = setTab;
    $[9] = t;
    $[10] = tab;
    $[11] = t10;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t10 = $[11];
    t3 = $[12];
    t4 = $[13];
    t5 = $[14];
    t6 = $[15];
    t7 = $[16];
    t8 = $[17];
    t9 = $[18];
  }
  let t11;
  if ($[67] !== t3 || $[68] !== t4 || $[69] !== t5 || $[70] !== t6) {
    t11 = <div className={t3}>{t4}{t5}{t6}</div>;
    $[67] = t3;
    $[68] = t4;
    $[69] = t5;
    $[70] = t6;
    $[71] = t11;
  } else {
    t11 = $[71];
  }
  let t12;
  if ($[72] !== t11 || $[73] !== t7 || $[74] !== t8 || $[75] !== t9) {
    t12 = <section>{t7}{t8}{t9}{t11}</section>;
    $[72] = t11;
    $[73] = t7;
    $[74] = t8;
    $[75] = t9;
    $[76] = t12;
  } else {
    t12 = $[76];
  }
  let t13;
  if ($[77] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = () => setIsAddDialogOpen(false);
    $[77] = t13;
  } else {
    t13 = $[77];
  }
  let t14;
  if ($[78] !== isAddDialogOpen || $[79] !== tab) {
    t14 = <CustomStatusAddDialog entityKind={tab} open={isAddDialogOpen} onClose={t13} />;
    $[78] = isAddDialogOpen;
    $[79] = tab;
    $[80] = t14;
  } else {
    t14 = $[80];
  }
  let t15;
  if ($[81] !== t10 || $[82] !== t12 || $[83] !== t14) {
    t15 = <>{t10}{t12}{t14}</>;
    $[81] = t10;
    $[82] = t12;
    $[83] = t14;
    $[84] = t15;
  } else {
    t15 = $[84];
  }
  return t15;
};
const OnboardingOutcomeCard = t0 => {
  const $ = _c(19);
  const {
    entityType
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "pages.statuses.onboardingOutcome"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("settings", t1);
  let t2;
  if ($[1] !== t) {
    t2 = t(_temp11);
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t(_temp12);
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = {
      id: "pass",
      slug: "pass",
      displayName: t3,
      hexCode: "#0A6A4A"
    };
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t) {
    t5 = t(_temp13);
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5) {
    t6 = {
      id: "fail",
      slug: "fail",
      displayName: t5,
      hexCode: "#991008"
    };
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t4 || $[12] !== t6) {
    t7 = [t4, t6];
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      data: {
        id: "1"
      },
      kind: "user"
    };
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== entityType || $[16] !== t2 || $[17] !== t7) {
    const status = {
      id: "onboarding-outcome",
      slug: "onboarding-outcome",
      entityType,
      displayName: t2,
      entries: t7,
      createdAt: "",
      createdByActor: t8,
      isDeactivated: false
    };
    t9 = <CustomStatusCard customStatus={status} canEdit={false} isBuiltIn={true} shouldShowSlug={false} />;
    $[15] = entityType;
    $[16] = t2;
    $[17] = t7;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
};
export default Statuses;
function _temp($) {
  return $.tabs.users;
}
function _temp2($_0) {
  return $_0.tabs.businesses;
}
function _temp3($_1) {
  return $_1.empty.users;
}
function _temp4($_2) {
  return $_2.empty.businesses;
}
function _temp5($_3) {
  return $_3.pageTitle;
}
function _temp6($_4) {
  return $_4.metaTitle;
}
function _temp7($_5) {
  return $_5.title;
}
function _temp8($_6) {
  return $_6.subtitle;
}
function _temp9($_7) {
  return $_7.notAllowed;
}
function _temp10($_8) {
  return $_8.add;
}
function _temp11($) {
  return $.title;
}
function _temp12($_0) {
  return $_0.entries.pass;
}
function _temp13($_1) {
  return $_1.entries.fail;
}